import { render, staticRenderFns } from "./settle-case-pool.vue?vue&type=template&id=c3998dd2&scoped=true"
import script from "./settle-case-pool.vue?vue&type=script&lang=ts"
export * from "./settle-case-pool.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3998dd2",
  null
  
)

export default component.exports